import { missingWidget } from '../utils/helpers';

export default function videoWidget2() {
  const widgetName = 'videoWidget';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof videoWidgetOpts === 'undefined' ? null : videoWidgetOpts;

  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }

  const addVideoTag = false;
  const tagText = 'Watch';

  $widget.append('<iframe></iframe>');
  $widget.wrap('<div id="videoSection"></div>');

  $widget.videoWidget({
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    detectIpad: IPADDETECTED,
    multiVideo: false,
    showOnMobile: true,
    autoPlayVideo: true,
    loopVideo: true, // autoPlayVideo must be enabled
    maxVideos: 1,

    videoWidgetLoaded: function (data) {
      if (data.Slides.length >= 1) {
        if (addVideoTag) {
          $('#videoSection').append(`<div class="video-tag">${tagText}</div`);
        }
      } else {
        $('#videoSection').remove();
        missingWidget(widgetName);
      }
    },
  });
}
